// src/components/account-summary-widget/loyalty-account-summary-widget.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    id\n    link: url\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n\n    ... on Mark {\n      ...EGDSMarkFragment\n    }\n\n    ... on Illustration {\n      ...EGDSIllustrationFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    __typename\n    theme\n    size\n    text\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyAccountBadgeFragment on LoyaltyAccountBadge {\n    creditCardIcon {\n      ...EGDSGraphicFragment\n    }\n    separator\n    tier {\n      ...EGDSStandardBadgeFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyAccountTravelerFragment on LoyaltyAccountTraveler {\n    __typename\n    title\n    emailAddress\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n        ... on HttpURI {\n          relativePath\n        }\n      }\n      target\n      useRelativePath\n    }\n    disabled\n    standardLinkIcon: icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    size\n    text\n  }\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    __typename\n    stylizedText: text\n    theme\n    weight\n    textSize: size\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment UILinkActionFragment on UILinkAction {\n    accessibility\n    target\n    resource {\n      __typename\n      value\n    }\n    analytics {\n      referrerId\n      linkName\n    }\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    __typename\n    action {\n      ...UILinkActionFragment\n    }\n    disabled\n    text\n    size\n  }\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextInlineContentFragment on EGDSSpannableTextItem {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSInlineLinkFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    inlineContent {\n      ...EGDSSpannableTextInlineContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    __typename\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment InfoIconFragment on Icon {\n    __typename\n    description\n    title\n    id\n    token\n    size\n    theme\n  }\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyAnchoredCurrencyDescriptionFragment on LoyaltyAnchoredCurrencyDescription {\n    balance {\n      ...EGDSStylizedTextFragment\n    }\n    subtitle {\n      ...EGDSStylizedTextFragment\n    }\n  }\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyAnchoredCurrencySectionFragment on LoyaltyAnchoredCurrencySection {\n    anchoredBalance {\n      ...LoyaltyAnchoredCurrencyDescriptionFragment\n    }\n    posaBalance {\n      ...LoyaltyAnchoredCurrencyDescriptionFragment\n    }\n    transferIcon {\n      ...EGDSIconFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyStylizedTextFragment on LoyaltyStylizedText {\n    stylizedText {\n      ...EGDSStylizedTextFragment\n    }\n  }\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyIconInfoOverlaySubContentFragment on LoyaltyIconInfoOverlaySubContent {\n    ...LoyaltyStylizedTextFragment\n    ...LoyaltyAnchoredCurrencySectionFragment\n  }\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyIconInfoContentSectionFragment on LoyaltyIconInfoContentSection {\n    __typename\n    actionText\n    contents {\n      ...LoyaltyIconInfoOverlaySubContentFragment\n    }\n    heading\n    analytics {\n      eventName\n      eventVersion\n      payload\n    }\n  }\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyIconAndDescriptionFragment on LoyaltyIconAndDescription {\n    __typename\n    iconInfoContentSection {\n      ...LoyaltyIconInfoContentSectionFragment\n    }\n    infoIcon {\n      ...InfoIconFragment\n    }\n    analytics {\n      eventName\n      eventVersion\n      payload\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyProgramTitleFragment on LoyaltyProgramTitle {\n    __typename\n    text\n    superScript\n    infoIconAndDescription {\n      ...LoyaltyIconAndDescriptionFragment\n    }\n  }\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyRewardsValueSectionFragment on LoyaltyRewardsValueSection {\n    __typename\n    title {\n      ...LoyaltyProgramTitleFragment\n    }\n    rewardsAmount\n    supportingMessages {\n      ...EGDSTextFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkWrapperFragment on EGDSInlineLink {\n    __typename\n    text\n    action {\n      ...UILinkActionFragment\n    }\n    size\n    disabled\n  }\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment LoyaltyViewRewardsLinkSectionFragment on LoyaltyViewRewardsLinkSection {\n    __typename\n    containerLink {\n      ...EGDSInlineLinkWrapperFragment\n    }\n    rewardsIcon {\n      ...EGDSIconFragment\n    }\n    rewardsText\n    containerLinkAnalytics {\n      payload\n      eventName\n      eventVersion\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  query LoyaltyAccountSummary($context: ContextInput!, $strategy: LoyaltyExperienceStrategy!, $viewId: String) {\n    loyaltyAccountSummary(context: $context, strategy: $strategy, viewId: $viewId) {\n      __typename\n      accessibilityLabel\n      traveler {\n        ...LoyaltyAccountTravelerFragment\n      }\n      viewRewardsLinkSection {\n        ...LoyaltyViewRewardsLinkSectionFragment\n      }\n      availableValueSection {\n        ...LoyaltyRewardsValueSectionFragment\n      }\n      badge {\n        ...LoyaltyAccountBadgeFragment\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n      theme {\n        lightMode {\n          themeProviderColor\n        }\n        darkMode {\n          themeProviderColor\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
import React29 from "react";
import { gql as gql27, useQuery } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
import { EGDSThemeProvider } from "@egds/react-core/utils";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
// ../internal/src/components/loyalty-account-badge/loyalty-account-badge.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSText } from "@egds/react-core/text";
// ../internal/src/components/egds-graphic/egds-icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
var __EGDSIconFragment = gql(_templateObject());
var LoyaltyEGDSIcon = function (param) {
  var className = param.className,
    theme = param.theme,
    _param_isAriaHidden = param.isAriaHidden,
    isAriaHidden = _param_isAriaHidden === void 0 ? false : _param_isAriaHidden,
    data = param.data;
  var spotlight = (data === null || data === void 0 ? void 0 : data.withBackground) ? "info" : void 0;
  var _data_title;
  return /* @__PURE__ */React.createElement(EGDSIcon, {
    className: className,
    description: isAriaHidden ? void 0 : data === null || data === void 0 ? void 0 : data.description,
    id: data === null || data === void 0 ? void 0 : data.id,
    name: data !== null ? data.id : "",
    size: (data === null || data === void 0 ? void 0 : data.size) ? EGDSIconSize[data.size] : void 0,
    title: isAriaHidden ? void 0 : (_data_title = data === null || data === void 0 ? void 0 : data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
    theme: theme || (data === null || data === void 0 ? void 0 : data.theme) || void 0,
    spotlight: spotlight
  });
};
LoyaltyEGDSIcon.displayName = "LoyaltyEGDSIcon";
LoyaltyEGDSIcon.fragment = __EGDSIconFragment;
// ../internal/src/components/egds-graphic/egds-illustration.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
var __EGDSIllustrationFragment = gql2(_templateObject1());
var EGDSIllustration = function (param) {
  var data = param.data;
  return /* @__PURE__ */React2.createElement(EGDSIllustrations, {
    alt: data.description,
    url: data.link
  });
};
EGDSIllustration.displayName = "Illustration";
EGDSIllustration.fragment = __EGDSIllustrationFragment;
// ../internal/src/components/egds-graphic/egds-mark.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
var __EGDSMarkFragment = gql3(_templateObject2());
var LoyaltyEGDSMark = function (param) {
  var className = param.className,
    markSize = param.markSize,
    data = param.data;
  var _data_url;
  return /* @__PURE__ */React3.createElement(EGDSMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id,
    size: markSize || data.markSize && EGDSMarkSize[data.markSize],
    url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
  });
};
LoyaltyEGDSMark.displayName = "LoyaltyEGDSMark";
LoyaltyEGDSMark.fragment = __EGDSMarkFragment;
// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
var __EGDSGraphicFragment = gql4(_templateObject3(), LoyaltyEGDSIcon.fragment, LoyaltyEGDSMark.fragment, EGDSIllustration.fragment);
var EGDSGraphic = function (param) {
  var className = param.className,
    markSize = param.markSize,
    data = param.data;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React4.createElement(LoyaltyEGDSIcon, {
        className: className,
        data: data
      });
    case "Mark":
      return /* @__PURE__ */React4.createElement(LoyaltyEGDSMark, {
        className: className,
        data: data,
        markSize: markSize
      });
    case "Illustration":
      return /* @__PURE__ */React4.createElement(EGDSIllustration, {
        data: data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;
// ../internal/src/components/egds-standard-badge/egds-standard-badge.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSBadgeLoyalty } from "@egds/react-core/badge";
var fragment = gql5(_templateObject4());
var EGDSStandardBadge = function (param) {
  var data = param.data;
  var theme = data.theme,
    size = data.size,
    text = data.text;
  var selectedTheme = theme ? theme : void 0;
  var selectedSize = size ? size : void 0;
  return /* @__PURE__ */React5.createElement(EGDSBadgeLoyalty, {
    text: text || void 0,
    theme: selectedTheme,
    size: selectedSize
  });
};
EGDSStandardBadge.fragment = fragment;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// ../internal/src/components/loyalty-account-badge/loyalty-account-badge.tsx
var fragment2 = gql6(_templateObject5(), EGDSGraphic.fragment, EGDSStandardBadge.fragment);
var CreditCardIconWithSeparator = function (param) {
  var creditCardIcon = param.creditCardIcon,
    separator = param.separator;
  if (creditCardIcon) {
    return /* @__PURE__ */React6.createElement(React6.Fragment, null, /* @__PURE__ */React6.createElement(EGDSText, {
      size: 200,
      weight: "medium"
    }, separator), /* @__PURE__ */React6.createElement(EGDSGraphic, {
      data: creditCardIcon
    }));
  }
  return null;
};
var LoyaltyAccountBadge = function (param) {
  var data = param.data;
  var creditCardIcon = data.creditCardIcon,
    separator = data.separator,
    tier = data.tier;
  return /* @__PURE__ */React6.createElement(EGDSLayoutFlex, {
    direction: "row",
    alignItems: "center",
    space: "one"
  }, /* @__PURE__ */React6.createElement(EGDSStandardBadge, {
    data: tier
  }), /* @__PURE__ */React6.createElement(CreditCardIconWithSeparator, {
    creditCardIcon: creditCardIcon,
    separator: separator
  }));
};
LoyaltyAccountBadge.fragment = fragment2;
LoyaltyAccountBadge.displayName = "sharedui-LoyaltyAccountBadge";
// ../internal/src/components/loyalty-account-traveler/loyalty-account-traveler.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var fragment3 = gql7(_templateObject6());
var LoyaltyAccountTraveler = function (param) {
  var data = param.data,
    _param_textSize = param.textSize,
    textSize = _param_textSize === void 0 ? 400 : _param_textSize;
  var title = data.title,
    emailAddress = data.emailAddress;
  return /* @__PURE__ */React7.createElement(React7.Fragment, null, /* @__PURE__ */React7.createElement(EGDSText2, {
    size: textSize,
    weight: "medium"
  }, title), /* @__PURE__ */React7.createElement(EGDSText2, {
    wordBreak: true
  }, emailAddress));
};
LoyaltyAccountTraveler.fragment = fragment3;
LoyaltyAccountTraveler.displayName = "LoyaltyAccountTraveler";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-rewards-value-section.tsx
import React24 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var fragment4 = gql8(_templateObject7());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    size = param.size,
    theme = param.theme,
    data = param.data;
  var text = data.text;
  return /* @__PURE__ */React8.createElement(EGDSText3, {
    className: className,
    inline: inline,
    size: size,
    theme: theme
  }, text);
};
EGDSPlainText.fragment = fragment4;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var _obj;
// ../internal/src/utils/link-mapper.ts
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */, "_self"), _obj);
var _obj1;
var linkSizeMapper = (_obj1 = {}, _define_property(_obj1, "SMALL" /* SMALL */, "small"), _define_property(_obj1, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj1, "LARGE" /* LARGE */, "large"), _obj1);
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment5 = gql9(_templateObject8(), LoyaltyEGDSIcon.fragment);
var getHrefFromLinkAction = function (param) {
  var resource = param.resource,
    useRelativePath = param.useRelativePath;
  switch (resource.__typename) {
    case "HttpURI":
      return useRelativePath ? resource.relativePath : resource.value;
    default:
      return resource.value;
  }
};
var IconPlacement = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    iconPositionToMatch = param.iconPositionToMatch;
  if (icon && iconPosition === iconPositionToMatch) {
    return /* @__PURE__ */React9.createElement(LoyaltyEGDSIcon, {
      data: icon
    });
  }
  return null;
};
var EGDSStandardLink = function (param) {
  var className = param.className,
    dataStid = param.dataStid,
    inline = param.inline,
    theme = param.theme,
    align = param.align,
    data = param.data,
    onClickHandler = param.onClickHandler;
  var _data_action = data.action,
    analytics = _data_action.analytics,
    target = _data_action.target,
    accessibility = _data_action.accessibility,
    disabled = data.disabled,
    iconPosition = data.iconPosition,
    standardLinkIcon = data.standardLinkIcon,
    size = data.size,
    text = data.text;
  var clickTracker = useClickTracker();
  var onClick = React9.useCallback(function () {
    clickTracker(analytics.referrerId, analytics.linkName);
    if (onClickHandler) {
      onClickHandler();
    }
  }, [clickTracker, analytics]);
  var getPath = React9.useCallback(function () {
    return getHrefFromLinkAction(data.action);
  }, [data.action]);
  return /* @__PURE__ */React9.createElement(EGDSLink, {
    className: className,
    "data-stid": dataStid,
    size: linkSizeMapper[size],
    onClickCapture: onClick,
    inline: inline,
    disabled: disabled,
    theme: theme || "default",
    align: align
  }, /* @__PURE__ */React9.createElement("a", {
    target: UILinkTargetMap[target],
    href: getPath()
  }, /* @__PURE__ */React9.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "LEADING" /* LEADING */
  }), text, /* @__PURE__ */React9.createElement(IconPlacement, {
    icon: standardLinkIcon,
    iconPosition: iconPosition,
    iconPositionToMatch: "TRAILING" /* TRAILING */
  }), accessibility && /* @__PURE__ */React9.createElement(EGDSText4, {
    className: "is-visually-hidden"
  }, accessibility)));
};
EGDSStandardLink.fragment = fragment5;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
// ../internal/src/utils/text-mapper.ts
var TextThemeMapper = /* @__PURE__ */function (TextThemeMapper2) {
  TextThemeMapper2["INVERSE"] = "inverse";
  TextThemeMapper2["LOYALTY"] = "loyalty";
  TextThemeMapper2["NEGATIVE"] = "negative";
  TextThemeMapper2["POSITIVE"] = "positive";
  TextThemeMapper2["PENDING"] = "default";
  return TextThemeMapper2;
}(TextThemeMapper || {});
var sizeMapper = {
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
};
var _obj2;
var textWeightMapper = (_obj2 = {}, _define_property(_obj2, "BOLD" /* BOLD */, "bold"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "REGULAR" /* REGULAR */, "regular"), _obj2);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment6 = gql10(_templateObject9());
var EGDSStylizedText = function (param) {
  var data = param.data,
    whiteSpace = param.whiteSpace,
    _param_useBackendTheme = param.useBackendTheme,
    useBackendTheme = _param_useBackendTheme === void 0 ? true : _param_useBackendTheme,
    align = param.align,
    inline = param.inline;
  var stylizedText = data.stylizedText,
    theme = data.theme,
    weight = data.weight,
    textSize = data.textSize;
  var themeToUse = useBackendTheme && theme ? TextThemeMapper[theme] : void 0;
  return /* @__PURE__ */React10.createElement(EGDSText5, {
    theme: themeToUse,
    align: align,
    whiteSpace: whiteSpace,
    weight: weight ? textWeightMapper[weight] : void 0,
    size: textSize ? sizeMapper[textSize] : void 0,
    inline: inline
  }, stylizedText);
};
EGDSStylizedText.fragment = fragment6;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React14, { Fragment } from "react";
import { gql as gql14 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-inline-content.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
// ../internal/src/components/egds-inline-link/egds-inline-link.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSLink as EGDSLink3, EGDSLinkSizes } from "@egds/react-core/link";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-inline-link-wrapper/ui-link-action.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { useClickTracker as useClickTracker2, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var fragment7 = gql11(_templateObject10());
var UILinkAction = function (param) {
  var children = param.children,
    data = param.data,
    onClick = param.onClick,
    size = param.size,
    disabled = param.disabled,
    isButton = param.isButton,
    inline = param.inline,
    clickstreamAnalyticsData = param.clickstreamAnalyticsData;
  var resource = data.resource,
    analytics = data.analytics,
    accessibility = data.accessibility;
  var clickTracker = useClickTracker2();
  var track = useEgClickstream();
  var onClickCapture = React11.useCallback(function () {
    if (analytics) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
    if ((clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.serverPayload) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventName) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: clickstreamAnalyticsData.eventName,
            event_version: clickstreamAnalyticsData.eventVersion
          }
        },
        serverPayload: clickstreamAnalyticsData.serverPayload
      });
    }
  }, [analytics, clickstreamAnalyticsData, clickTracker, track]);
  return isButton ? /* @__PURE__ */React11.createElement(EGDSLink2, {
    onClick: onClick,
    size: size,
    disabled: disabled,
    inline: inline
  }, /* @__PURE__ */React11.createElement("button", {
    type: "button",
    onClickCapture: onClickCapture,
    "aria-label": accessibility || ""
  }, children)) : /* @__PURE__ */React11.createElement("a", {
    href: resource.value,
    onClickCapture: onClickCapture,
    "aria-label": accessibility || ""
  }, children);
};
UILinkAction.fragment = fragment7;
UILinkAction.displayName = "UILinkAction";
// ../internal/src/components/egds-inline-link/egds-inline-link.tsx
var fragment8 = gql12(_templateObject11(), UILinkAction.fragment);
var EGDSInlineLink = function (param) {
  var data = param.data,
    onClickHandler = param.onClickHandler;
  var action = data.action,
    disabled = data.disabled,
    size = data.size,
    text = data.text;
  var clickTracker = useClickTracker3();
  var onClick = React12.useCallback(function () {
    clickTracker(action.analytics.referrerId, action.analytics.linkName);
    if (onClickHandler) {
      onClickHandler();
    }
  }, [clickTracker, action.analytics]);
  return /* @__PURE__ */React12.createElement(EGDSLink3, {
    onClick: onClick,
    inline: true,
    disabled: disabled,
    size: EGDSLinkSizes[size]
  }, /* @__PURE__ */React12.createElement("a", {
    href: action.resource.value,
    target: action.target
  }, text, action.accessibility && /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, action.accessibility)));
};
EGDSInlineLink.fragment = fragment8;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-inline-content.tsx
var fragment9 = gql13(_templateObject12(), EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSStandardLink.fragment, EGDSInlineLink.fragment);
var EGDSSpannableTextInlineContent = function (param) {
  var size = param.size,
    align = param.align,
    theme = param.theme,
    data = param.data;
  switch (data.__typename) {
    case "EGDSStylizedText":
      return /* @__PURE__ */React13.createElement(EGDSStylizedText, {
        align: align,
        data: data,
        inline: true
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React13.createElement(EGDSPlainText, {
        data: data,
        size: size,
        theme: theme,
        inline: true
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React13.createElement(EGDSStandardLink, {
        data: data
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React13.createElement(EGDSInlineLink, {
        data: data
      });
    default:
      return null;
  }
};
EGDSSpannableTextInlineContent.fragment = fragment9;
EGDSSpannableTextInlineContent.displayName = "EGDSSpannableTextInlineContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment10 = gql14(_templateObject13(), EGDSSpannableTextInlineContent.fragment);
var EGDSSpannableText = function (param) {
  var align = param.align,
    data = param.data,
    size = param.size,
    theme = param.theme;
  var _data_inlineContent;
  if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
    return /* @__PURE__ */React14.createElement(React14.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React14.createElement(Fragment, {
        key: "inline-content-".concat(index)
      }, /* @__PURE__ */React14.createElement(EGDSSpannableTextInlineContent, {
        align: align,
        data: item,
        size: size,
        theme: theme
      }), " ");
    }));
  }
  return null;
};
EGDSSpannableText.fragment = fragment10;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
var fragment11 = gql15(_templateObject14(), EGDSPlainText.fragment, EGDSStandardLink.fragment);
var LoyaltyEGDSText = function (param) {
  var data = param.data,
    standardLinkProps = param.standardLinkProps,
    plainTextProps = param.plainTextProps;
  var __typename = data.__typename;
  switch (__typename) {
    case "EGDSStandardLink":
      return /* @__PURE__ */React15.createElement(EGDSStandardLink, _object_spread({
        data: data
      }, standardLinkProps));
    case "EGDSPlainText":
      return /* @__PURE__ */React15.createElement(EGDSPlainText, _object_spread({
        data: data
      }, plainTextProps));
    default:
      return null;
  }
};
LoyaltyEGDSText.fragment = fragment11;
LoyaltyEGDSText.displayName = "LoyaltyEGDSText";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-program-title.tsx
import React23 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-and-description.tsx
import React22, { useRef } from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSButtonSize, EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSDialog, EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
// ../internal/src/components/loyalty-rewards-value-section/info-icon.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
var fragment12 = gql16(_templateObject15());
var InfoIcon = function (param) {
  var data = param.data;
  var description = data.description,
    title = data.title,
    id = data.id,
    token = data.token,
    size = data.size,
    theme = data.theme;
  var iconSize = size ? EGDSIconSize2[size] : void 0;
  var iconTheme = theme !== null && theme !== void 0 ? theme : void 0;
  return /* @__PURE__ */React16.createElement(EGDSIcon2, {
    id: id,
    title: title || void 0,
    description: description,
    name: id,
    size: iconSize,
    theme: iconTheme
  });
};
InfoIcon.fragment = fragment12;
InfoIcon.displayName = "InfoIcon";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-info-content-section.tsx
import React21, { useEffect } from "react";
import { gql as gql21 } from "@apollo/client";
import { EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSHeading } from "@egds/react-core/text";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/loyalty-icon-info-overlay-subcontent/loyalty-icon-info-overlay-subcontent.tsx
import React20 from "react";
import { gql as gql20 } from "@apollo/client";
// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-section.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-description.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
var fragment13 = gql17(_templateObject16(), EGDSStylizedText.fragment);
var LoyaltyAnchoredCurrencyDescription = function (param) {
  var data = param.data;
  var balance = data.balance,
    subtitle = data.subtitle;
  return /* @__PURE__ */React17.createElement(EGDSLayoutFlex2, {
    alignItems: "center",
    direction: "column"
  }, /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React17.createElement(EGDSStylizedText, {
    data: balance
  })), /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem, {
    maxWidth: "37x"
  }, /* @__PURE__ */React17.createElement("div", null, /* @__PURE__ */React17.createElement(EGDSStylizedText, {
    align: "center",
    data: subtitle
  }))));
};
LoyaltyAnchoredCurrencyDescription.fragment = fragment13;
LoyaltyAnchoredCurrencyDescription.displayName = "LoyaltyAnchoredCurrencyDescription";
// ../internal/src/components/loyalty-anchored-currency-section/loyalty-anchored-currency-section.tsx
var fragment14 = gql18(_templateObject17(), LoyaltyAnchoredCurrencyDescription.fragment, LoyaltyEGDSIcon.fragment);
var LoyaltyAnchoredCurrencySection = function (param) {
  var data = param.data;
  var anchoredBalance = data.anchoredBalance,
    posaBalance = data.posaBalance,
    transferIcon = data.transferIcon;
  return /* @__PURE__ */React18.createElement(EGDSLayoutFlex3, {
    space: "two"
  }, /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React18.createElement(LoyaltyAnchoredCurrencyDescription, {
    data: posaBalance
  })), /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React18.createElement(LoyaltyEGDSIcon, {
    data: transferIcon
  })), /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React18.createElement(LoyaltyAnchoredCurrencyDescription, {
    data: anchoredBalance
  })));
};
LoyaltyAnchoredCurrencySection.fragment = fragment14;
LoyaltyAnchoredCurrencySection.displayName = "LoyaltyAnchoredCurrencySection";
// ../internal/src/components/loyalty-stylized-text/loyalty-stylized-text.tsx
import React19 from "react";
import { gql as gql19 } from "@apollo/client";
var fragment15 = gql19(_templateObject18(), EGDSStylizedText.fragment);
var LoyaltyStylizedText = function (param) {
  var data = param.data,
    stylizedTextProps = param.stylizedTextProps;
  var stylizedText = data.stylizedText;
  return /* @__PURE__ */React19.createElement(EGDSStylizedText, _object_spread({
    data: stylizedText
  }, stylizedTextProps));
};
LoyaltyStylizedText.fragment = fragment15;
LoyaltyStylizedText.displayName = "LoyaltyStylizedText";
// ../internal/src/components/loyalty-icon-info-overlay-subcontent/loyalty-icon-info-overlay-subcontent.tsx
var fragment16 = gql20(_templateObject19(), LoyaltyStylizedText.fragment, LoyaltyAnchoredCurrencySection.fragment);
var LoyaltyIconInfoOverlaySubContent = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "LoyaltyStylizedText":
      return /* @__PURE__ */React20.createElement(LoyaltyStylizedText, {
        data: data,
        stylizedTextProps: {
          align: "center"
        }
      });
    case "LoyaltyAnchoredCurrencySection":
      return /* @__PURE__ */React20.createElement(LoyaltyAnchoredCurrencySection, {
        data: data
      });
    default:
      return null;
  }
};
LoyaltyIconInfoOverlaySubContent.fragment = fragment16;
LoyaltyIconInfoOverlaySubContent.displayName = "LoyaltyIconInfoOverlaySubContent";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-info-content-section.tsx
var fragment17 = gql21(_templateObject20(), LoyaltyIconInfoOverlaySubContent.fragment);
var LoyaltyIconInfoContentSection = function (param) {
  var data = param.data,
    onClick = param.onClick;
  var actionText = data.actionText,
    contents = data.contents,
    heading = data.heading,
    analytics = data.analytics;
  var track = useEgClickstream2();
  useEffect(function () {
    if ((analytics === null || analytics === void 0 ? void 0 : analytics.payload) && (analytics === null || analytics === void 0 ? void 0 : analytics.eventName) && (analytics === null || analytics === void 0 ? void 0 : analytics.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: analytics.eventName,
            event_version: analytics.eventVersion
          }
        },
        serverPayload: analytics.payload
      });
    }
  }, []);
  return /* @__PURE__ */React21.createElement(EGDSLayoutFlex4, {
    direction: "column",
    space: "four"
  }, /* @__PURE__ */React21.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React21.createElement(EGDSHeading, {
    align: "center"
  }, heading)), contents === null || contents === void 0 ? void 0 : contents.map(function (item, index) {
    return /* @__PURE__ */React21.createElement(EGDSLayoutFlexItem3, {
      key: index,
      alignSelf: "center"
    }, /* @__PURE__ */React21.createElement("div", null, /* @__PURE__ */React21.createElement(LoyaltyIconInfoOverlaySubContent, {
      data: item
    })));
  }), /* @__PURE__ */React21.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React21.createElement(EGDSTertiaryButton, {
    onClick: onClick
  }, actionText)));
};
LoyaltyIconInfoContentSection.fragment = fragment17;
LoyaltyIconInfoContentSection.displayName = "LoyaltyIconInfoContentSection";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-icon-and-description.tsx
var fragment18 = gql22(_templateObject21(), LoyaltyIconInfoContentSection.fragment, InfoIcon.fragment);
var LoyaltyIconAndDescription = function (param) {
  var data = param.data;
  var infoIcon = data.infoIcon,
    iconInfoContentSection = data.iconInfoContentSection,
    analytics = data.analytics;
  var dialogKey = React22.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var _useDialog = _sliced_to_array(useDialog("one-key-info-dialog-".concat(dialogKey)), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var triggerRef = useRef(null);
  var handleInfoClick = function (event) {
    event.stopPropagation();
    dialogActions.closeDialog();
  };
  var track = useEgClickstream3();
  var handleClick = React22.useCallback(function () {
    if ((analytics === null || analytics === void 0 ? void 0 : analytics.payload) && (analytics === null || analytics === void 0 ? void 0 : analytics.eventName) && (analytics === null || analytics === void 0 ? void 0 : analytics.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: analytics.eventName,
            event_version: analytics.eventVersion
          }
        },
        serverPayload: analytics.payload
      });
    }
    dialogActions.openDialog();
  }, [track, analytics, dialogActions]);
  return /* @__PURE__ */React22.createElement(React22.Fragment, null, /* @__PURE__ */React22.createElement(EGDSSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React22.createElement(DialogComponent, null, /* @__PURE__ */React22.createElement(EGDSDialog, {
    dialogShow: isDialogOpen,
    triggerRef: triggerRef,
    returnFocusOnClose: true
  }, /* @__PURE__ */React22.createElement(EGDSDialogContent, null, /* @__PURE__ */React22.createElement(LoyaltyIconInfoContentSection, {
    data: iconInfoContentSection,
    onClick: handleInfoClick
  }))))), /* @__PURE__ */React22.createElement(EGDSTertiaryButton2, {
    onClick: handleClick,
    size: EGDSButtonSize.SMALL,
    domRef: triggerRef
  }, /* @__PURE__ */React22.createElement(InfoIcon, {
    data: infoIcon
  })));
};
LoyaltyIconAndDescription.fragment = fragment18;
LoyaltyIconAndDescription.displayName = "LoyaltyIconAndDescription";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-program-title.tsx
var fragment19 = gql23(_templateObject22(), LoyaltyIconAndDescription.fragment);
var LoyaltyProgramTitle = function (param) {
  var data = param.data;
  var text = data.text,
    superScript = data.superScript,
    infoIconAndDescription = data.infoIconAndDescription;
  return /* @__PURE__ */React23.createElement(EGDSLayoutFlex5, {
    alignItems: "center"
  }, /* @__PURE__ */React23.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React23.createElement(EGDSText6, null, text, " ", /* @__PURE__ */React23.createElement("sup", null, superScript))), /* @__PURE__ */React23.createElement(EGDSLayoutFlexItem4, null, infoIconAndDescription ? /* @__PURE__ */React23.createElement(LoyaltyIconAndDescription, {
    data: infoIconAndDescription
  }) : null));
};
LoyaltyProgramTitle.fragment = fragment19;
LoyaltyProgramTitle.displayName = "LoyaltyProgramTitle";
// ../internal/src/components/loyalty-rewards-value-section/loyalty-rewards-value-section.tsx
var fragment20 = gql24(_templateObject23(), LoyaltyProgramTitle.fragment, LoyaltyEGDSText.fragment);
var LoyaltyRewardsValueSection = function (param) {
  var data = param.data,
    textSize = param.textSize;
  var title = data.title,
    rewardsAmount = data.rewardsAmount,
    supportingMessages = data.supportingMessages;
  return /* @__PURE__ */React24.createElement(React24.Fragment, null, /* @__PURE__ */React24.createElement(LoyaltyProgramTitle, {
    data: title
  }), /* @__PURE__ */React24.createElement(EGDSText7, {
    weight: "medium",
    size: textSize
  }, rewardsAmount), supportingMessages === null || supportingMessages === void 0 ? void 0 : supportingMessages.map(function (supportingMessage, index) {
    return /* @__PURE__ */React24.createElement(LoyaltyEGDSText, {
      data: supportingMessage,
      standardLinkProps: {
        inline: true
      },
      key: index
    });
  }));
};
LoyaltyRewardsValueSection.fragment = fragment20;
LoyaltyRewardsValueSection.displayName = "LoyaltyRewardsValueSection";
// ../internal/src/components/loyalty-view-rewards-link-section/loyalty-view-rewards-link-section.tsx
import React26 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSPrimaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker4, useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-inline-link-wrapper/egds-inline-link-wrapper.tsx
import React25 from "react";
import { gql as gql25 } from "@apollo/client";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
var fragment21 = gql25(_templateObject24(), UILinkAction.fragment);
var EGDSInlineLinkWrapper = function (param) {
  var data = param.data,
    onClick = param.onClick,
    isButton = param.isButton,
    inline = param.inline,
    clickstreamAnalyticsData = param.clickstreamAnalyticsData,
    children = param.children;
  return /* @__PURE__ */React25.createElement(UILinkAction, {
    data: data.action,
    onClick: onClick,
    isButton: isButton,
    inline: inline,
    clickstreamAnalyticsData: clickstreamAnalyticsData
  }, data.text ? /* @__PURE__ */React25.createElement(EGDSHeading2, null, data.text) : children);
};
EGDSInlineLinkWrapper.fragment = fragment21;
EGDSInlineLinkWrapper.displayName = "EGDSInlineLinkWrapper";
// ../internal/src/components/loyalty-view-rewards-link-section/loyalty-view-rewards-link-section.tsx
var fragment22 = gql26(_templateObject25(), EGDSInlineLinkWrapper.fragment, LoyaltyEGDSIcon.fragment);
var LoyaltyViewRewardsLinkSection = function (param) {
  var data = param.data,
    ctaIsButton = param.ctaIsButton;
  var containerLink = data.containerLink,
    rewardsIcon = data.rewardsIcon,
    rewardsText = data.rewardsText,
    containerLinkAnalytics = data.containerLinkAnalytics;
  var clickstreamAnalyticsData = {
    serverPayload: containerLinkAnalytics === null || containerLinkAnalytics === void 0 ? void 0 : containerLinkAnalytics.payload,
    eventName: containerLinkAnalytics === null || containerLinkAnalytics === void 0 ? void 0 : containerLinkAnalytics.eventName,
    eventVersion: containerLinkAnalytics === null || containerLinkAnalytics === void 0 ? void 0 : containerLinkAnalytics.eventVersion
  };
  var clickTracker = useClickTracker4();
  var track = useEgClickstream4();
  var handleButtonClick = React26.useCallback(function () {
    if (containerLink === null || containerLink === void 0 ? void 0 : containerLink.action.analytics) {
      clickTracker(containerLink === null || containerLink === void 0 ? void 0 : containerLink.action.analytics.referrerId, containerLink === null || containerLink === void 0 ? void 0 : containerLink.action.analytics.linkName);
    }
    if ((clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.serverPayload) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventName) && (clickstreamAnalyticsData === null || clickstreamAnalyticsData === void 0 ? void 0 : clickstreamAnalyticsData.eventVersion)) {
      track({
        clientPayload: {
          event: {
            event_name: clickstreamAnalyticsData.eventName,
            event_version: clickstreamAnalyticsData.eventVersion
          }
        },
        serverPayload: clickstreamAnalyticsData.serverPayload
      });
    }
  }, [containerLink === null || containerLink === void 0 ? void 0 : containerLink.action.analytics, clickstreamAnalyticsData, clickTracker, track]);
  if (!containerLink) {
    return null;
  }
  if (ctaIsButton) {
    return /* @__PURE__ */React26.createElement(EGDSLayoutFlex6, {
      justifyContent: "center"
    }, /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React26.createElement(EGDSPrimaryButton, {
      onClick: handleButtonClick,
      tag: "a",
      href: containerLink === null || containerLink === void 0 ? void 0 : containerLink.action.resource.value
    }, rewardsText)));
  }
  return /* @__PURE__ */React26.createElement(EGDSInlineLinkWrapper, {
    data: containerLink,
    clickstreamAnalyticsData: clickstreamAnalyticsData
  }, /* @__PURE__ */React26.createElement(EGDSLayoutFlex6, {
    alignItems: "center",
    space: "four"
  }, rewardsIcon ? /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React26.createElement(LoyaltyEGDSIcon, {
    data: rewardsIcon
  })) : null, /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem5, {
    grow: 1
  }, /* @__PURE__ */React26.createElement(EGDSText8, {
    theme: "global-loyalty"
  }, rewardsText)), /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem5, null, /* @__PURE__ */React26.createElement(EGDSIcon3, {
    name: "chevron_right",
    theme: "default"
  }))));
};
LoyaltyViewRewardsLinkSection.fragment = fragment22;
LoyaltyViewRewardsLinkSection.displayName = "LoyaltyViewRewardsLinkSection";
var _obj3;
// ../internal/src/utils/theme-provider-mapper.ts
var themeProviderMapper = (_obj3 = {}, _define_property(_obj3, "NONE" /* NONE */, "none"), _define_property(_obj3, "LIGHT_1" /* LIGHT_1 */, "light-1"), _define_property(_obj3, "DARK_1" /* DARK_1 */, "dark-1"), _define_property(_obj3, "BRIGHT_1" /* BRIGHT_1 */, "bright-1"), _define_property(_obj3, "GLOBAL_LOYALTY_STANDARD" /* GLOBAL_LOYALTY_STANDARD */, "global-loyalty-standard"), _define_property(_obj3, "GLOBAL_LOYALTY_LOW" /* GLOBAL_LOYALTY_LOW */, "global-loyalty-low"), _define_property(_obj3, "GLOBAL_LOYALTY_LOW_BRIGHT" /* GLOBAL_LOYALTY_LOW_BRIGHT */, "global-loyalty-low-bright"), _define_property(_obj3, "GLOBAL_LOYALTY_MID" /* GLOBAL_LOYALTY_MID */, "global-loyalty-mid"), _define_property(_obj3, "GLOBAL_LOYALTY_MID_BRIGHT" /* GLOBAL_LOYALTY_MID_BRIGHT */, "global-loyalty-mid-bright"), _define_property(_obj3, "GLOBAL_LOYALTY_HIGH" /* GLOBAL_LOYALTY_HIGH */, "global-loyalty-high"), _define_property(_obj3, "GLOBAL_LOYALTY_HIGH_BRIGHT" /* GLOBAL_LOYALTY_HIGH_BRIGHT */, "global-loyalty-high-bright"), _define_property(_obj3, "GLOBAL_LOYALTY_EXTRA_HIGH" /* GLOBAL_LOYALTY_EXTRA_HIGH */, "global-loyalty-extra-high"), _define_property(_obj3, "GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT" /* GLOBAL_LOYALTY_EXTRA_HIGH_BRIGHT */, "global-loyalty-extra-high-bright"), _define_property(_obj3, "STANDARD" /* STANDARD */, "standard"), _define_property(_obj3, "MARKETING_1" /* MARKETING_1 */, "marketing-1"), _define_property(_obj3, "MARKETING_2" /* MARKETING_2 */, "marketing-2"), _obj3);
// src/__generated__/types.ts
var LoyaltyExperienceStrategy = /* @__PURE__ */function (LoyaltyExperienceStrategy2) {
  LoyaltyExperienceStrategy2["HIDE_TRAVELER_INFO_AND_REWARDS_LINK"] = "HIDE_TRAVELER_INFO_AND_REWARDS_LINK";
  LoyaltyExperienceStrategy2["SHOW_TRAVELER_INFO_AND_REWARDS_LINK"] = "SHOW_TRAVELER_INFO_AND_REWARDS_LINK";
  return LoyaltyExperienceStrategy2;
}(LoyaltyExperienceStrategy || {});
// src/components/common/available-value.tsx
import React27 from "react";
import { EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
var AvailableValue = function (param) {
  var availableValueSection = param.availableValueSection,
    alignItemsOption = param.alignItemsOption,
    textSize = param.textSize,
    _param_cardContentSectionPadding = param.cardContentSectionPadding,
    cardContentSectionPadding = _param_cardContentSectionPadding === void 0 ? false : _param_cardContentSectionPadding,
    badge = param.badge;
  if (!availableValueSection) {
    return null;
  }
  return /* @__PURE__ */React27.createElement(EGDSCardContentSection, {
    padded: cardContentSectionPadding
  }, /* @__PURE__ */React27.createElement(EGDSSpacing, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React27.createElement(EGDSLayoutFlex7, {
    direction: "column",
    alignItems: alignItemsOption,
    space: "one"
  }, badge && /* @__PURE__ */React27.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React27.createElement(LoyaltyAccountBadge, {
    data: badge
  })), /* @__PURE__ */React27.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React27.createElement(LoyaltyRewardsValueSection, {
    data: availableValueSection,
    textSize: textSize
  })))));
};
// src/components/common/traveler-and-tier-badge-section.tsx
import React28 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
var TravelerAndTierBadgeSection = function (param) {
  var badge = param.badge,
    traveler = param.traveler,
    textSize = param.textSize;
  if (traveler && badge) {
    return /* @__PURE__ */React28.createElement(EGDSLayoutFlex8, {
      alignItems: "center",
      wrap: "wrap",
      space: "one"
    }, /* @__PURE__ */React28.createElement(EGDSLayoutFlexItem7, {
      grow: 1
    }, /* @__PURE__ */React28.createElement(EGDSLayoutFlex8, {
      direction: "column"
    }, /* @__PURE__ */React28.createElement(LoyaltyAccountTraveler, {
      data: traveler,
      textSize: textSize
    }))), /* @__PURE__ */React28.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React28.createElement(LoyaltyAccountBadge, {
      data: badge
    })));
  }
  if (traveler) {
    return /* @__PURE__ */React28.createElement(LoyaltyAccountTraveler, {
      data: traveler
    });
  }
  if (badge) {
    return /* @__PURE__ */React28.createElement(LoyaltyAccountBadge, {
      data: badge
    });
  }
  return null;
};
// src/components/account-summary-widget/loyalty-account-summary-widget.tsx
var __Query = gql27(_templateObject26(), LoyaltyAccountTraveler.fragment, LoyaltyViewRewardsLinkSection.fragment, LoyaltyRewardsValueSection.fragment, LoyaltyAccountBadge.fragment);
var LoyaltyAccountSummaryWidget = function (props) {
  var _theme_lightMode, _theme_darkMode, _theme_lightMode1, _theme_darkMode1;
  var skipSsr = props.skipSsr,
    shouldHideTraveler = props.shouldHideTraveler,
    inputs = props.inputs;
  var context = useBexApi().context;
  var variables = _object_spread({
    context: context
  }, inputs);
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var isTravelerInfoAndRewardsLinkHidden = inputs.strategy === "HIDE_TRAVELER_INFO_AND_REWARDS_LINK" /* HIDE_TRAVELER_INFO_AND_REWARDS_LINK */;
  var isHeaderView = inputs.viewId === "HeaderView" /* HEADER */;
  if (loading) {
    return /* @__PURE__ */React29.createElement(EGDSLayoutFlex9, {
      justifyContent: "center"
    }, /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React29.createElement(EGDSLoader, null)));
  }
  if (error || !data || !data.loyaltyAccountSummary) {
    return null;
  }
  var _data_loyaltyAccountSummary = data.loyaltyAccountSummary,
    badge = _data_loyaltyAccountSummary.badge,
    traveler = _data_loyaltyAccountSummary.traveler,
    viewRewardsLinkSection = _data_loyaltyAccountSummary.viewRewardsLinkSection,
    availableValueSection = _data_loyaltyAccountSummary.availableValueSection,
    impressionAnalytics = _data_loyaltyAccountSummary.impressionAnalytics,
    accessibilityLabel = _data_loyaltyAccountSummary.accessibilityLabel,
    theme = _data_loyaltyAccountSummary.theme;
  return /* @__PURE__ */React29.createElement(Experiment, {
    name: "Bringing_Visibility_to_One_Key_Status"
  }, /* @__PURE__ */React29.createElement(ExperimentControl, null, /* @__PURE__ */React29.createElement(EGDSCard, {
    "data-stid": "loyalty-account-summary"
  }, accessibilityLabel && /* @__PURE__ */React29.createElement(EGDSHeading3, {
    tag: "h2",
    className: "is-visually-hidden"
  }, accessibilityLabel), /* @__PURE__ */React29.createElement(EGDSLayoutFlex9, {
    direction: "column",
    alignItems: isTravelerInfoAndRewardsLinkHidden ? "center" : void 0
  }, !shouldHideTraveler && traveler && /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React29.createElement(EGDSCardContentSection2, null, !isHeaderView && !isTravelerInfoAndRewardsLinkHidden && /* @__PURE__ */React29.createElement(LoyaltyAccountTraveler, {
    data: traveler,
    textSize: 600
  }), isHeaderView && /* @__PURE__ */React29.createElement(TravelerAndTierBadgeSection, {
    badge: badge,
    traveler: traveler
  }))), /* @__PURE__ */React29.createElement(EGDSSpacing2, {
    margin: {
      blockstart: !isHeaderView && !isTravelerInfoAndRewardsLinkHidden ? "three" : "unset"
    }
  }, /* @__PURE__ */React29.createElement(EGDSCard, {
    border: !isHeaderView && !isTravelerInfoAndRewardsLinkHidden
  }, /* @__PURE__ */React29.createElement(EGDSLayoutFlex9, {
    direction: "column"
  }, /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem8, {
    alignSelf: isHeaderView ? "start" : "center"
  }, impressionAnalytics ? /* @__PURE__ */React29.createElement(IntersectionTracker, {
    referrerId: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId,
    linkName: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName
  }, /* @__PURE__ */React29.createElement(AvailableValue, {
    availableValueSection: availableValueSection,
    textSize: !isHeaderView && !isTravelerInfoAndRewardsLinkHidden ? 600 : 400,
    alignItemsOption: isHeaderView ? "start" : "center",
    cardContentSectionPadding: isHeaderView ? ["blockend", "inlinestart", "inlineend"] : true,
    badge: isHeaderView ? null : badge
  })) : /* @__PURE__ */React29.createElement(AvailableValue, {
    availableValueSection: availableValueSection,
    textSize: !isHeaderView && !isTravelerInfoAndRewardsLinkHidden ? 600 : 400,
    alignItemsOption: isHeaderView ? "start" : "center",
    cardContentSectionPadding: isHeaderView ? ["blockend", "inlinestart", "inlineend"] : true,
    badge: isHeaderView ? null : badge
  })), /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem8, {
    alignSelf: "stretch"
  }, viewRewardsLinkSection && /* @__PURE__ */React29.createElement(EGDSCardContentSection2, {
    padded: ["blockend", "inlinestart", "inlineend"]
  }, /* @__PURE__ */React29.createElement(LoyaltyViewRewardsLinkSection, {
    data: viewRewardsLinkSection
  }))))))))), /* @__PURE__ */React29.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React29.createElement(EGDSThemeProvider, {
    config: {
      lightMode: {
        colorTheme: isTravelerInfoAndRewardsLinkHidden && (theme === null || theme === void 0 ? void 0 : (_theme_lightMode = theme.lightMode) === null || _theme_lightMode === void 0 ? void 0 : _theme_lightMode.themeProviderColor) ? themeProviderMapper[theme.lightMode.themeProviderColor] : "none"
      },
      darkMode: {
        colorTheme: isTravelerInfoAndRewardsLinkHidden && (theme === null || theme === void 0 ? void 0 : (_theme_darkMode = theme.darkMode) === null || _theme_darkMode === void 0 ? void 0 : _theme_darkMode.themeProviderColor) ? themeProviderMapper[theme.darkMode.themeProviderColor] : "none"
      }
    }
  }, /* @__PURE__ */React29.createElement(EGDSCard, {
    "data-stid": "loyalty-account-summary"
  }, accessibilityLabel && /* @__PURE__ */React29.createElement(EGDSHeading3, {
    tag: "h2",
    className: "is-visually-hidden"
  }, accessibilityLabel), /* @__PURE__ */React29.createElement(EGDSLayoutFlex9, {
    direction: "column",
    alignItems: isTravelerInfoAndRewardsLinkHidden ? "center" : void 0
  }, !shouldHideTraveler && traveler && /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React29.createElement(EGDSCardContentSection2, null, /* @__PURE__ */React29.createElement(LoyaltyAccountTraveler, {
    data: traveler,
    textSize: 600
  }))), /* @__PURE__ */React29.createElement(EGDSSpacing2, {
    margin: {
      blockstart: isTravelerInfoAndRewardsLinkHidden ? "unset" : "three"
    }
  }, /* @__PURE__ */React29.createElement("div", null, /* @__PURE__ */React29.createElement(EGDSThemeProvider, {
    config: {
      lightMode: {
        colorTheme: (theme === null || theme === void 0 ? void 0 : (_theme_lightMode1 = theme.lightMode) === null || _theme_lightMode1 === void 0 ? void 0 : _theme_lightMode1.themeProviderColor) ? themeProviderMapper[theme.lightMode.themeProviderColor] : "none"
      },
      darkMode: {
        colorTheme: (theme === null || theme === void 0 ? void 0 : (_theme_darkMode1 = theme.darkMode) === null || _theme_darkMode1 === void 0 ? void 0 : _theme_darkMode1.themeProviderColor) ? themeProviderMapper[theme.darkMode.themeProviderColor] : "none"
      }
    }
  }, /* @__PURE__ */React29.createElement(EGDSCard, null, /* @__PURE__ */React29.createElement(EGDSLayoutFlex9, {
    direction: "column"
  }, /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem8, {
    alignSelf: "center"
  }, impressionAnalytics ? /* @__PURE__ */React29.createElement(IntersectionTracker, {
    referrerId: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId,
    linkName: impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName
  }, /* @__PURE__ */React29.createElement(AvailableValue, {
    availableValueSection: availableValueSection,
    textSize: 600,
    alignItemsOption: "center",
    cardContentSectionPadding: true,
    badge: badge
  })) : /* @__PURE__ */React29.createElement(AvailableValue, {
    availableValueSection: availableValueSection,
    textSize: 600,
    alignItemsOption: "center",
    cardContentSectionPadding: true,
    badge: badge
  })), /* @__PURE__ */React29.createElement(EGDSLayoutFlexItem8, {
    alignSelf: "center"
  }, viewRewardsLinkSection && /* @__PURE__ */React29.createElement(EGDSCardContentSection2, {
    padded: ["blockend", "inlinestart", "inlineend"]
  }, /* @__PURE__ */React29.createElement(LoyaltyViewRewardsLinkSection, {
    data: viewRewardsLinkSection,
    ctaIsButton: true
  })))))))))))));
};
LoyaltyAccountSummaryWidget.displayName = "sharedui-Loyalty Account Summary Widget";
export { LoyaltyAccountSummaryWidget, LoyaltyExperienceStrategy };